/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { Fragment, useState, useRef, useEffect } from 'react';
import { ScheduleList } from './ScheduleList';
import { CustomForm } from './CustomForm';
import usePrevious from "../../../../Shared/components/Previous";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { emptyValidation } from "../../../../../helpers/validation";
import { checkViewPermission } from '../../../../../helpers/utilities';
import groupActions from "../../../../Sales/Setup/redux/actions";
import salesActions from "../../../../Sales/Management/redux/actions";
import younoteAdminActions from "../../../../YounoteAdmin/Setup/redux/actions";
import { ScheduleQuery } from './ScheduleQuery';
import { AESDecrypt } from "../../../../../helpers/Crypto";
import { useParams } from "react-router-dom";


const ScheduleTransactions = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const [view, setView] = useState('schedule-list');
    const { workflowDetails, frequencyDetails } = useSelector(state => state.younoteAdminSetupReducer);
    const { createDetails, createError } = useSelector(state => state.crudReducer);
    const scheduleRef = useRef('');
    const queryRef = useRef('');
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const [error, setError] = useState({});
    const { history } = props;
    const { values } = useParams();
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const [form, setForm] = useState({});
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch();

    const handleOpen = (d) => {
        setVisible(d);
        emptyState();
        emptyStateInput();
        customerApi();
    }

    const emptyState = () => {
        setError({});
    }

    const emptyStateInput = () => {
        setForm({ filterBy: 'ALL', dataOfSchedule: new Date() });
    };


    const customObject = (details, id) => {
        let a = details && details.filter((el) => el.id === id);
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            toast('The Transactions has been Scheduled Successfully');
            setView('schedule-list');
            setTimeout(() => {
                scheduleRef?.current?.dispatchFilter();
            });
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission(`Schedule Transactions`, history, 'Admin')) {
                loadTasks();
            }
        }
        return () => {
            dispatch({ type: salesActions.CLEAR_MANAGEMENT_DETAILS_START });
        };
    }, [roleManagement]);

    const loadTasks = () => {
        dispatch({
            type: groupActions.CUSTOMERGROUP_DETAILS_START, url: 'customer-group', filter: {
                order: 'id desc'
            }
        });
        customerApi();
        dispatch({
            type: younoteAdminActions.FREQUENCY_START, url: 'v1/schedules/schedule-frequency', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: younoteAdminActions.WORKFLOW_START, url: 'v1/schedules/workflow', filter: {
                order: 'id  desc'
            }
        });
    }

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    useEffect(() => {
        if (values) {
            setForm({ ...AESDecrypt(values) });
            setView('price');
            setTimeout(() => {
                queryRef?.current?.dispatchFilter(AESDecrypt(values));
            });
            setVisible(false);
        } else {
            scheduleRef?.current?.dispatchFilter();
        }
    }, [values]);


    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e
            });
        } else {
            if (e.target.name === 'filterBy') {
                setError({});
            }
            setForm({
                ...form,
                [e.target.name]: e.target.value
            });
        }
    }

    const createSchedule = (e) => {
        e.preventDefault();
        let group = true;
        let customer = true;
        let emptyGroup = '';
        let emptyCustomer = '';
        if (form.filterBy === 'GROUP') {
            emptyGroup = emptyValidation('Customer Group', form.groupId, 'dropDown');
            group = emptyGroup.isValid;
        } else if (form.filterBy === 'SPECIFIC') {
            emptyCustomer = emptyValidation('Customer', form.customerId, 'dropDown');
            customer = emptyCustomer.isValid;
        }
        if (group && customer) {
            setView('schedule-query');
            setTimeout(() => {
                queryRef?.current?.dispatchFilter(form);
            });
            setVisible(false);
        } else {
            setError({
                'groupId': emptyGroup.errors,
                'customerId': emptyCustomer.errors,
            })
        }
    }

    const handleCancelQuery = (t) => {
        setView(t);
        setTimeout(() => {
            if (t === 'schedule-list') {
                scheduleRef?.current?.dispatchFilter(t);
            } else if (t === 'schedule-query') {
                queryRef?.current?.dispatchFilter(form);
            }
        });
    }

    return (
        <Fragment>
            {
                view === 'schedule-list' ? <ScheduleList ref={scheduleRef}
                    handleOpen={(data) => handleOpen(data)}
                    customerApi={(s = '', id = '') => customerApi(s, id)}
                    {...props}
                /> : <ScheduleQuery customObject={(deatils, id) => customObject(deatils, id)} {...props}
                    view={'schedule-query'}
                    changeHandler={(e, name) => changeHandler(e, name)}
                    handleClose={(type) => { handleCancelQuery(type); customerApi() }}
                    ref={queryRef} form={form}
                />
            }
            <CustomForm
                customObject={(details, id) => customObject(details, id)}
                visible={visible}
                handleClose={() => handleOpen(false)}
                createSchedule={(e) => createSchedule(e)}
                changeHandler={(e, name) => changeHandler(e, name)}
                form={form}
                error={error}
                customerApi={(s = '', id = '') => customerApi(s, id)}
                customerDetails={customerDetails}
                customerGroupdetails={customerGroupdetails}
                workflowDetails={workflowDetails}
                frequencyDetails={frequencyDetails}
            />
        </Fragment>
    );
}

export default ScheduleTransactions;